import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

export default class PaymentLink extends BaseAPIModel {
    static list(item) {
        return [item];
    }

    static listUrl({ organizationId, eventId, orderId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][PaymentLink] organizationId, eventId and orderId are mandatory');
        }
        return `/ticket/organizations/${organizationId}/events/${eventId}/orders/${orderId}/payment_link`;
    }
}
